export default __webpack_public_path__ + "static/media/comming-soon.c92a6ef9.svg";